import { BLOOMLIFE_SUPPORT_URL } from "@/util/constants"

const ContactSupportLink = () => (
  <p className="text-center text-sm text-support">
    Need help?{" "}
    <a
      href={BLOOMLIFE_SUPPORT_URL}
      target="_blank"
      rel="noreferrer"
      className="font-medium underline"
    >
      Contact Bloomlife support
    </a>
  </p>
)

export default ContactSupportLink
